import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class ProgressBarOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    const showProgressBar: boolean = map.get(DeliveryOptionConstants.SHOW_PROGRESS_BAR) as boolean;
    const progressBarColor: string = map.get(DeliveryOptionConstants.PROGRESS_BAR_COLOR) as string;

    if (showProgressBar && progressBarColor && progressBarColor.trim().length > 0) {
      const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.SHOW_PROGRESS_BAR);
      deliveryOption.addSetting('color', progressBarColor);

      provider.addDeliveryOption(deliveryOption);
    }
  }
}

export default ProgressBarOptionHandler;
